import { useDispatch, useSelector } from 'react-redux';
import { Button, Surface, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { cookieManager } from '@app/services/storageManager';
import { postProfileMessage, selectUser, sendMessageToMobileApp } from '@app/redux';
import { EventTypes } from '@app/types';

import { PushNotificationImage } from './PushNotificationImage';

import styles from './styles.module.scss';

export const FIRST_TIME_PUSH = 'FIRST_TIME_PUSH';
export const PUSH_ENABLED = 'PUSH_ENABLED';

const AcceptPush = ({ onAccept }: { onAccept?: () => void }): JSX.Element => {
  const dispatch = useDispatch();
  const {
    user: { accountNumber },
  } = useSelector(selectUser);
  const { t } = useTranslation('AcceptPush');

  const requestPermission = () => {
    dispatch(
      postProfileMessage({
        eventType: EventTypes.PushNotification,
        data: true,
      })
    );
    dispatch(
      sendMessageToMobileApp({
        type: 'set-push-notification-status',
        data: { shouldSubscribeToPushNotifications: true },
      })
    );
  };

  const onButtonClick = () => {
    cookieManager.set(`${FIRST_TIME_PUSH}${accountNumber}`, '1', {
      secure: true,
      expiresInDays: 999,
    });
    onAccept && onAccept();
  };

  return (
    <Surface className={styles['main']} data-cy="pushNotification">
      <Surface className={styles['contentWrapper']}>
        <Surface className={styles['imageWrapper']}>
          <PushNotificationImage />
        </Surface>
        <Surface>
          <Txt variant="heading4" style={{ textAlign: 'center', marginBottom: 16 }}>
            {t('GetNotifications')}
          </Txt>
          <Txt variant="bodyLargeRegular" style={{ textAlign: 'center' }}>
            {t('NotificationInformation')}
          </Txt>
        </Surface>
      </Surface>
      <Surface className={styles['buttonWrapper']}>
        <Button
          onClick={(): void => {
            requestPermission();
            onButtonClick();
          }}
          style={{ marginBottom: 12 }}
        >
          {t('AllowNotifications')}
        </Button>
        <Button
          data-cy="rejectPush"
          variant="secondary"
          onClick={(e): void => {
            onButtonClick();
          }}
        >
          {t('DeclineNotifications')}
        </Button>
      </Surface>
    </Surface>
  );
};

export default AcceptPush;
